import { useContext } from "react";
import { Box, IconButton, Sheet, Typography } from "@mui/joy";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { LayoutContext } from "../context";

const STYLES = {
  success: { bg: "#ecfdf5", border: "#a7f3d0", color: "#065f46", icon: "✓" },
  warning: { bg: "#fffbeb", border: "#fde68a", color: "#92400e", icon: "!" },
  danger:  { bg: "#fef2f2", border: "#fecaca", color: "#991b1b", icon: "×" },
  neutral: { bg: "#f8fafc", border: "#e2e8f0", color: "#334155", icon: "i" },
};

export default function Toasts() {
  const { toasts, dismissToast } = useContext(LayoutContext);
  if (!toasts || toasts.length === 0) return null;

  return (
    <Box
      sx={{
        position: "fixed", zIndex: 20000,
        bottom: { xs: 12, md: 20 }, right: { xs: 12, md: 20 },
        left: { xs: 12, md: "auto" },
        display: "flex", flexDirection: "column", gap: 1,
        maxWidth: { xs: "auto", md: 420 },
        pointerEvents: "none",
      }}
    >
      {toasts.map((t) => {
        const s = STYLES[t.kind] || STYLES.neutral;
        return (
          <Sheet
            key={t.id}
            sx={{
              p: 1.5, borderRadius: "14px",
              bgcolor: s.bg, border: `1px solid ${s.border}`,
              boxShadow: "0 12px 32px -18px rgba(0,0,0,0.45)",
              display: "flex", alignItems: "flex-start", gap: 1,
              pointerEvents: "auto",
            }}
          >
            <Box
              sx={{
                width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
                bgcolor: s.color, color: "white",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "0.75rem", fontWeight: 800, mt: 0.1,
              }}
            >
              {s.icon}
            </Box>
            <Typography level="body-sm" sx={{ color: s.color, flex: 1 }}>
              {t.text}
            </Typography>
            <IconButton size="sm" variant="plain" onClick={() => dismissToast(t.id)} sx={{ minHeight: 20, minWidth: 20 }}>
              <CloseRoundedIcon sx={{ fontSize: 16, color: s.color }} />
            </IconButton>
          </Sheet>
        );
      })}
    </Box>
  );
}